// extracted by mini-css-extract-plugin
export default {"cards":"Cards_cards__qwjTj","badge":"Cards_badge__fzbLD"};